import { render, staticRenderFns } from "./FinalAdminReport.vue?vue&type=template&id=04c581c6&scoped=true"
import script from "./FinalAdminReport.vue?vue&type=script&lang=js"
export * from "./FinalAdminReport.vue?vue&type=script&lang=js"
import style0 from "./FinalAdminReport.vue?vue&type=style&index=0&id=04c581c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c581c6",
  null
  
)

export default component.exports